import 'promise-polyfill/dist/polyfill';
import 'whatwg-fetch';

if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

[Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach((prototype) => {
  if (!prototype.remove) {
    prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
});
